/**
 * Generated by orval v6.12.1 🍺
 * Do not edit manually.
 * Platz API
 * Platz API boi
 * OpenAPI spec version: 2.0
 */
import { useQuery, useMutation } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type {
  TagView,
  PlatzApiError,
  Tag,
  SnippetsForTagView,
  CreateTagInstanceRequest,
} from ".././model";
import { customInstance } from "../../../axios";
import type { ErrorType, BodyType } from "../../../axios";

export const getAllUserTags = (signal?: AbortSignal) => {
  return customInstance<TagView[]>({ url: `/api/tags`, method: "get", signal });
};

export const getGetAllUserTagsQueryKey = () => [`/api/tags`];

export type GetAllUserTagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllUserTags>>
>;
export type GetAllUserTagsQueryError = ErrorType<PlatzApiError>;

export const useGetAllUserTags = <
  TData = Awaited<ReturnType<typeof getAllUserTags>>,
  TError = ErrorType<PlatzApiError>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAllUserTags>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllUserTagsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllUserTags>>> = ({
    signal,
  }) => getAllUserTags(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getAllUserTags>>,
    TError,
    TData
  >({ queryKey, queryFn, ...queryOptions }) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

export const updateTag = (tag: BodyType<Tag>) => {
  return customInstance<TagView>({
    url: `/api/tags`,
    method: "put",
    headers: { "Content-Type": "application/json" },
    data: tag,
  });
};

export type UpdateTagMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTag>>
>;
export type UpdateTagMutationBody = BodyType<Tag>;
export type UpdateTagMutationError = ErrorType<PlatzApiError>;

export const useUpdateTag = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTag>>,
    TError,
    { data: BodyType<Tag> },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTag>>,
    { data: BodyType<Tag> }
  > = (props) => {
    const { data } = props ?? {};

    return updateTag(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof updateTag>>,
    TError,
    { data: BodyType<Tag> },
    TContext
  >(mutationFn, mutationOptions);
};
export const createTag = (tag: BodyType<Tag>) => {
  return customInstance<TagView>({
    url: `/api/tags`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: tag,
  });
};

export type CreateTagMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTag>>
>;
export type CreateTagMutationBody = BodyType<Tag>;
export type CreateTagMutationError = ErrorType<PlatzApiError>;

export const useCreateTag = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTag>>,
    TError,
    { data: BodyType<Tag> },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTag>>,
    { data: BodyType<Tag> }
  > = (props) => {
    const { data } = props ?? {};

    return createTag(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof createTag>>,
    TError,
    { data: BodyType<Tag> },
    TContext
  >(mutationFn, mutationOptions);
};
export const getAllTaggedInstances = (signal?: AbortSignal) => {
  return customInstance<SnippetsForTagView[]>({
    url: `/api/tags/instances`,
    method: "get",
    signal,
  });
};

export const getGetAllTaggedInstancesQueryKey = () => [`/api/tags/instances`];

export type GetAllTaggedInstancesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllTaggedInstances>>
>;
export type GetAllTaggedInstancesQueryError = ErrorType<PlatzApiError>;

export const useGetAllTaggedInstances = <
  TData = Awaited<ReturnType<typeof getAllTaggedInstances>>,
  TError = ErrorType<PlatzApiError>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAllTaggedInstances>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllTaggedInstancesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllTaggedInstances>>
  > = ({ signal }) => getAllTaggedInstances(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getAllTaggedInstances>>,
    TError,
    TData
  >({ queryKey, queryFn, ...queryOptions }) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

export const createTagInstance = (
  createTagInstanceRequest: BodyType<CreateTagInstanceRequest>
) => {
  return customInstance<void>({
    url: `/api/tags/instances`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: createTagInstanceRequest,
  });
};

export type CreateTagInstanceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTagInstance>>
>;
export type CreateTagInstanceMutationBody = BodyType<CreateTagInstanceRequest>;
export type CreateTagInstanceMutationError = ErrorType<PlatzApiError>;

export const useCreateTagInstance = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTagInstance>>,
    TError,
    { data: BodyType<CreateTagInstanceRequest> },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTagInstance>>,
    { data: BodyType<CreateTagInstanceRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createTagInstance(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof createTagInstance>>,
    TError,
    { data: BodyType<CreateTagInstanceRequest> },
    TContext
  >(mutationFn, mutationOptions);
};
export const deleteTag = (id: number) => {
  return customInstance<void>({ url: `/api/tags/${id}`, method: "delete" });
};

export type DeleteTagMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTag>>
>;

export type DeleteTagMutationError = ErrorType<PlatzApiError>;

export const useDeleteTag = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTag>>,
    TError,
    { id: number },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTag>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTag(id);
  };

  return useMutation<
    Awaited<ReturnType<typeof deleteTag>>,
    TError,
    { id: number },
    TContext
  >(mutationFn, mutationOptions);
};
